import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";

import { NpaNxxService } from "@onsip/common/services/api/resources/npanxx/npanxx.service";
import {
  NpaNxx,
  Nxx,
  TOLL_FREE_NPAS,
  UNKNOWN
} from "@onsip/common/services/api/resources/npanxx/npanxx";

// NOTE
// Npa = Area Code
// Nxx = Rate center/local prefix

/**
 * to use this is for any component:
 * 1. import AddPhoneNumberDialogModule
 * 2. this.dialog.open(AddNumberDialogComponent, {
      panelClass: ["mat-typography", "onsip-dialog-universal-style"],
      disableClose: true
    });
 */

interface IMatDialogInputData {
  disableToggles: boolean;
}

@Component({
  selector: "onsip-add-phone-number-dialog",
  templateUrl: "./add-phone-number-dialog.component.html",
  styleUrls: ["./add-phone-number-dialog.component.scss"],
  standalone: false
})
export class AddNumberDialogComponent implements OnInit, OnDestroy {
  addPhoneNumber = new FormGroup({});
  npaNxxs: Array<NpaNxx> = [];
  nxxs: Array<Nxx> = [];

  buttonToggleFormControl = new FormControl("single");
  showSearchScreen = false;
  showPurchaseSpinner = false;

  private unsubscriber = new Subscription();

  constructor(
    private dialogRef: MatDialogRef<AddNumberDialogComponent>,
    private npaNxxService: NpaNxxService,
    @Inject(MAT_DIALOG_DATA) public data: IMatDialogInputData | undefined
  ) {}

  ngOnInit() {
    this.npaNxxService.NpaNxxBrowse();
    this.unsubscriber.add(
      this.npaNxxService.state
        .pipe(
          filter(({ loading }) => !loading),
          map(({ state }) => Object.values(state))
        )
        .subscribe(npaNxxs => {
          this.npaNxxs = npaNxxs.sort((a, b) => {
            const aIsTollFree = TOLL_FREE_NPAS.includes(a.num);
            const bIsTollFree = TOLL_FREE_NPAS.includes(b.num);
            const aIsUnknown = UNKNOWN.includes(a.num);
            const bIsUnknown = UNKNOWN.includes(b.num);
            const aPostalCode = a.postalCode;
            const bPostalCode = b.postalCode;
            if (aIsTollFree && !bIsTollFree) return -1;
            if (bIsTollFree && !aIsTollFree) return 1;
            if (aIsUnknown && !bIsUnknown) return -1;
            if (bIsUnknown && !aIsUnknown) return 1;
            if (!aPostalCode && bPostalCode) return 1;
            if (!bPostalCode && aPostalCode) return -1;
            if (aIsTollFree && bIsTollFree) return a.num < b.num ? -1 : 1;
            if (a.postalCode && b.postalCode) return a.postalCode.name < b.postalCode.name ? -1 : 1;
            return 1;
          });
        })
    );
  }

  closeAddNumberForm(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  handleShowSearchScreen(event: boolean): void {
    this.showSearchScreen = event;
  }

  handleShowPurchaseSpinner(event: boolean): void {
    this.showPurchaseSpinner = event;
  }
}
